import { Route, Routes } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useEffect } from "react";
import Url from "../../../apiCall/UrlConfig";
import { message } from "antd";
import NumberTeethMainPage from "./NumberTeethMainPage";
import AnalysesNumberTeeth from "./AnalysesNumberTeeth";
import ListAnalysesNumberTeeth from "./ListAnalysesNumberTeeth";

const RouterNumberingTeeth = (props) => {
  useEffect(() => {
    _getUserInfo();
  }, []);

  const _getUserInfo = async () => {
    let url = Url.getuserIfNumberTeeth;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  let userObj = props.coreData[Url.getuserIfNumberTeeth]?.[Url.action]?.data;

  return (
    <div>
      {userObj?.examPassed && (
        <Routes>
          <Route
            path="/mainpage/analyses/:id"
            element={<AnalysesNumberTeeth />}
          />
          <Route
            path="/mainpage/analyses/:id/:idAnalyses"
            element={<AnalysesNumberTeeth />}
          />
          <Route path="/mainpage" element={<NumberTeethMainPage />} />
          <Route
            path="/mainpage/youranalyses"
            element={<ListAnalysesNumberTeeth />}
          />
        </Routes>
      )}

      {userObj?.examPassed === false && (
        <>
          <div>You Dont Have Enough Permission</div>
        </>
      )}
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RouterNumberingTeeth);
